export default __webpack_public_path__ + "static/media/workout-plan.f7643f43.png";